import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOptimizelyFlags, IOptimizelyFlagVariations } from 'app/models/Optimizely/Optimizely';
import { optimizelyInitialState } from './initialState';
import { serviceActions } from './optimizely.actions';
import _ from 'lodash';

const optimizelySlice = createSlice({
  name: 'optimizelyFlags',
  initialState: optimizelyInitialState,
  reducers: {
    setOptimizelyFlags(state, action: PayloadAction<IOptimizelyFlags>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setOptimizelyFlagVariation(state, action: PayloadAction<{ key: string; variation: IOptimizelyFlagVariations }>) {
      const itemIndex = state.items.findIndex(item => item.key === action.payload.key);
      if (itemIndex !== -1) {
        const newItems = _.cloneDeep(state.items);
        newItems[itemIndex].variations = action.payload.variation;
        return {
          ...state,
          items: newItems,
        };
      } else return state;
    },
    reset() {
      return {
        ...optimizelyInitialState,
      };
    },
  },
});

const { actions } = optimizelySlice;
export const { reducer: optimizelyReducer, name: optimizelySliceKey } = optimizelySlice;
export const optimizelyActions = {
  ...actions,
  ...serviceActions,
};
